import styled from 'styled-components';

import { media } from '@simplywallst/ui-core';

interface DropdownItemProps {
  isSelected: boolean;
}

export const DropdownItem = styled('a')<DropdownItemProps>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  width: 240px;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);

  ${({ isSelected, theme }) =>
    isSelected &&
    ` &&& {
      background: ${theme.color.brand01RGBA(0.1)};
    }
  `}
  ${media.mdUp`
    &:hover {
      background: ${({ theme }) => theme.color.paper};
    }
  `}
`;

export const DropdownItemIcon = styled('div')`
  > svg {
    opacity: 0.5;
    fill: ${({ theme }) => theme.color.black};
    padding-right: ${({ theme }) => theme.x4space}px;
  }
`;

export const DeleteButton = styled('a')`
  padding-right: ${({ theme }) => theme.x1spacePx}px;
  min-height: 36px;
  min-width: 36px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 0;

  > svg {
    cursor: pointer;
    opacity: 0.3;
    border-radius: ${({ theme }) => theme.x6space}px;
    fill: ${({ theme }) => theme.color.black};

    ${media.mdUp`
      &:hover {
        background: ${({ theme }) => theme.color.lightGray};
      }
    `}
  }
`;
